import { render } from "./NftSortFilterComp.vue?vue&type=template&id=8882311e&ts=true"
import script from "./NftSortFilterComp.vue?vue&type=script&lang=ts"
export * from "./NftSortFilterComp.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__